// Khai DỮ LIỆU (không phải logic) cho "Xuất/Nhập hàng loạt" phân hệ Khóa học - đối xứng với BE
// config/course_import_export.php (key phải khớp NHAU giữa 2 phía). Mirror
// src/views/Workspace/FamilyBook/import_export_config.js, khác: KHÔNG generic hoá UI (mỗi entity ở
// đây cần bố cục khác hẳn nhau) - mỗi entity có 1 file Panel riêng
// (StudentPanels.js/AttendancePanels.js/GradePanels.js), tất cả cùng dùng lại phần chung ở
// CourseImportExportShared.js.
export const IMPORT_EXPORT_ENTITIES = {
    student: {
        key: 'student',
        label: 'course bulk entity student label',
    },
    attendance: {
        key: 'attendance',
        label: 'course bulk entity attendance label',
    },
    grade: {
        key: 'grade',
        label: 'course bulk entity grade label',
    },
}

export const IMPORT_EXPORT_ENTITY_ORDER = ['student', 'attendance', 'grade']

// 2 mode Xuất/Nhập Học viên - TÁCH RIÊNG HOÀN TOÀN (chọn trước khi Xuất, không trộn trong 1 file).
export const STUDENT_IMPORT_MODES = Object.freeze({
    INSERT: 'insert',
    UPSERT: 'upsert',
})

// 2 phương thức chống trùng học viên - chỉ áp dụng cho mode=insert (Nhập mới, chưa biết học viên đã
// tồn tại trong hệ thống hay chưa). Label/hint dùng chung cho cả màn Xuất (gợi ý field cần điền) và
// màn Nhập (bắt buộc chọn lại trước khi upload file, xem StudentImportPanel).
export const DEDUP_METHODS = Object.freeze({
    NAME_GENDER_DOB: 'name_gender_dob',
    IDENTIFIER: 'identifier',
})

export const DEDUP_METHOD_OPTIONS = [
    {
        value: DEDUP_METHODS.NAME_GENDER_DOB,
        label: 'dedup method name gender dob label',
        hint: 'dedup method name gender dob hint',
    },
    {
        value: DEDUP_METHODS.IDENTIFIER,
        label: 'dedup method identifier label',
        hint: 'dedup method identifier hint',
    },
]

// Điểm danh/Điểm số: KHÔNG có khái niệm "tạo mới học viên" (học viên trong 1 buổi/1 cột điểm luôn là
// sĩ số lớp đã biết) nên 2 mode nghĩa khác Học viên - "insert" = tạo buổi/cột MỚI (xuất TOÀN BỘ sĩ số
// lớp), "upsert" = cập nhật buổi/cột ĐÃ CÓ (chọn 1 buổi/cột có sẵn, xuất dữ liệu hiện tại để sửa).
export const SESSION_IMPORT_MODES = Object.freeze({
    INSERT: 'insert',
    UPSERT: 'upsert',
})

// 4 trạng thái điểm danh thật (khớp AttendanceDetail.status: 1/-1/-2/-3) - tiếng Anh viết hoa, đủ cả
// "Đi trễ" (luồng cũ P/A/E chỉ có 3 mã, thiếu trạng thái này).
export const ATTENDANCE_STATUS_OPTIONS = [
    {value: 'PRESENT', label: 'attendance status present'},
    {value: 'EXCUSED', label: 'attendance status excused'},
    {value: 'ABSENT', label: 'attendance status absent'},
    {value: 'LATE', label: 'attendance status late'},
]

// 2 thang điểm thật (khớp Grade.score_type: number/text, cột Excel hiện chữ hoa cho dễ đọc).
export const GRADE_SCORE_TYPE_OPTIONS = [
    {value: 'NUMBER', label: 'grade score type number'},
    {value: 'TEXT', label: 'grade score type text'},
]
